import {
  QueryDocumentSnapshot,
  Timestamp,
  type DocumentData,
  type SnapshotOptions
} from 'firebase/firestore'
import { FirebaseProperties } from '@/types/Helper/FirebaseProperties'
import type { ObjectSummary } from '@/types/Helper/Interfaces'
import { FirebaseCollections, FirestorePaths } from '@/utils/firestore/FirestorePaths'

export class Room extends FirebaseProperties {
  name = ''
  description = ''
  location = ''
  picture = ''
  capacity = 0
  isSimulator = false
  isReservable = true
  isActive = false

  constructor(data?: Partial<Room>) {
    super()
    Object.assign(this, data)
  }

  setStore(storeId: string) {
    const id = this.firebaseInfo?.__id

    this.thisCollection = FirestorePaths.storeCollection(storeId, FirebaseCollections.Rooms)

    this.thisDocument = id
      ? FirestorePaths.storeDocument(storeId, FirebaseCollections.Rooms, id)
      : this.thisCollection
  }

  getId(): string {
    return this.firebaseInfo.__id
  }

  getSummary(): ObjectSummary {
    return {
      id: this.firebaseInfo.__id,
      name: this.getName(),
      active: this.isActive
    }
  }

  getName(): string {
    return this.name
  }

  getActive(): boolean {
    return this.isActive
  }

  getSearchables(): string {
    return `${this.name} ${this.capacity}`.trim()
  }

  createCopy(): Room {
    return new Room({
      ...this,
      firebaseInfo: { ...this.firebaseInfo }
    })
  }
}

export const RoomConverter = {
  toFirestore: (room: Room) => {
    const firebaseInfo = {
      ...room.firebaseInfo,
      _updatedAt: Timestamp.now()
    }

    return {
      name: room.name,
      isActive: room.isActive,
      isReservable: room.isReservable,
      description: room.description,
      location: room.location,
      picture: room.picture,
      isSimulator: room.isSimulator,
      capacity: room.capacity,
      firebaseInfo
    }
  },

  fromFirestore: (
    snapshot: QueryDocumentSnapshot<DocumentData, DocumentData>,
    options?: SnapshotOptions
  ) => {
    const data = snapshot.data(options)
    return new Room(data)
  }
}
